import { urls } from "./urls";
import { queries } from "./queries";

class UrlFactory {
  _constructUrlQuery(...urlQueries) {
    var url = "";

    if (urlQueries[0] !== undefined && urlQueries[0] !== null) {
      urlQueries[0].forEach(query => {
        if (
          query.value !== undefined &&
          query.value !== null &&
          query.value !== ""
        ) {
          if (url.length > 0) {
            url += queries.QUERY_SEPARATOR;
          }
          url += query.name + queries.QUERY_NAME_VALUE_SEPARATOR + query.value;
        }
      });
    }

    return url;
  }

  _constructUrlQueries(urlQueries) {
    var url = this._constructUrlQuery(urlQueries);

    if (url.length > 0) {
      url = queries.QUERY_START + url;
    }

    return url;
  }

  _constructPaginationQuery(pageInfo) {
    if (pageInfo === undefined) return undefined;

    const urlQueries = [
      { name: queries.PAGE_QUERY, value: pageInfo.number },
      { name: queries.SIZE_QUERY, value: pageInfo.size }
    ];

    return this._constructUrlQuery(urlQueries);
  }

  _constructSortQuery(sortInfo) {
    if (!sortInfo || !sortInfo.orderBy) return undefined;

    const urlQueries = [
      {
        name: queries.SORT,
        value: sortInfo.orderBy + "," + sortInfo.direction
      }
    ];

    return this._constructUrlQuery(urlQueries);
  }

  constructPasswordRequirementsQuery(authenticationType) {
    const urlQueries = [
      { name: queries.AUTHENTICATION_TYPE_QUERY, value: authenticationType }
    ];

    return this._constructUrlQueries(urlQueries);
  }

  constructCheckUsernameQuery(authenticationType, username) {
    const urlQueries = [
      { name: queries.AUTHENTICATION_TYPE_QUERY, value: authenticationType },
      { name: queries.USERNAME_QUERY, value: username }
    ];

    return this._constructUrlQueries(urlQueries);
  }

  constructCheckEmailQuery(authenticationType, email) {
    const urlQueries = [
      { name: queries.AUTHENTICATION_TYPE_QUERY, value: authenticationType },
      { name: queries.EMAIL_QUERY, value: email }
    ];

    return this._constructUrlQueries(urlQueries);
  }

  _constructFilteringQuery(filters) {
    var urlQueries = [];

    if (filters !== null && filters !== undefined) {
      Object.keys(filters).forEach(function (key) {
        const filter = filters[key];
        var comparator = undefined;
        var value = undefined;
        switch (filter.filterType) {
          case "TEXT":
            switch (filter.comparator) {
              case "LIKE":
                comparator = "like";
                break;
              case "=":
                comparator = "eq";
                break;
              default:
                break;
            }
            value = filter.filterVal;
            break;
          case "BOOLEAN": {
            value = filter.filterVal;
            break;
          }
          case "NUMBER":
            switch (filter.filterVal.comparator) {
              case "=":
                comparator = "eq";
                break;
              case "!=":
                comparator = "neq";
                break;
              case ">":
                comparator = "gt";
                break;
              case ">=":
                comparator = "gte";
                break;
              case "<":
                comparator = "lt";
                break;
              case "<=":
                comparator = "lte";
                break;
              default:
                break;
            }
            value = filter.filterVal.number;
            break;
          case "SELECT": {
            switch (filter.comparator) {
              case "=":
                comparator = "eq";
                break;
              case "IN":
                comparator = "in";
                break;
              case "NOTIN":
                comparator = "nin";
                break;
              default:
                break;
            }
            if (Array.isArray(filter.filterVal)) {
              value = filter.filterVal.join();
            } else {
              value = filter.filterVal;
            }
            break;
          }
          default:
            break;
        }
        if (comparator !== undefined && value !== undefined && value !== "") {
          urlQueries.push({
            name: key,
            value:
              comparator + queries.FILTERING_COMPARATOR_SEPARATOR_QUERY + value
          });
        }
        if (!comparator && value && value !== "") {
          urlQueries.push({
            name: key,
            value: value
          });
        }
      });
    }

    return this._constructUrlQuery(urlQueries);
  }

  constructPaginationAndFilteringUrlQueries(
    pageInfo,
    sortInfo,
    alreadyContainsUrlParams = false
  ) {
    var urlQueries = "";
    var filters = null;
    if (pageInfo) {
      filters = pageInfo.filters;
    }

    const paginationQuery = this._constructPaginationQuery(pageInfo);
    const sortQuery = this._constructSortQuery(sortInfo);
    const filteringQuery = this._constructFilteringQuery(filters);

    const query_start = alreadyContainsUrlParams
      ? queries.QUERY_SEPARATOR
      : queries.QUERY_START;

    if (paginationQuery && paginationQuery.length > 0) {
      urlQueries += query_start + paginationQuery;
      if (sortQuery && sortQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + sortQuery;
      }
      if (filteringQuery && filteringQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + filteringQuery;
      }
    } else if (filteringQuery && filteringQuery.length > 0) {
      urlQueries += query_start + filteringQuery;
      if (sortQuery && sortQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + sortQuery;
      }
    } else if (sortQuery && sortQuery.length > 0) {
      urlQueries += query_start + sortQuery;
    }

    return urlQueries;
  }

  checkUrlContainsParams(url) {
    const indexOfQueryStart = url.indexOf(queries.QUERY_START);
    if (indexOfQueryStart && indexOfQueryStart !== -1) {
      const params = url.substring(indexOfQueryStart);
      if (params && params.length > 0) {
        return true;
      }
    }
    return false;
  }

  _itemlUrl(collectionUrl, id) {
    return collectionUrl + urls.URL_SEPARATOR + id;
  }
  loginUrl() {
    return urls.LOGIN_URL;
  }
  logoutUrl() {
    return urls.LOGOUT_URL;
  }
  registerUrl() {
    return urls.REGISTER_URL;
  }
  passwordRequirementsUrl() {
    return urls.PASSWORD_REQUIREMENTS_URL;
  }
  checkUsernameUrl() {
    return urls.CHECK_USERNAME_URL;
  }
  checkEmailUrl() {
    return urls.CHECK_EMAIL_URL;
  }
  usersUrl() {
    return urls.USERS_URL;
  }
  userUrl(userId) {
    return this._itemlUrl(urls.USERS_URL, userId);
  }
  userSystemProcessesUrl(userId) {
    return this.userUrl(userId) + this.systemProcessesUrl();
  }
  systemProcessesUrl() {
    return urls.SYSTEM_PROCESSES_URL;
  }
  classificationTypes() {
    return urls.CLASSIFICATION_TYPES_URL;
  }
  classificationStatuses() {
    return urls.CLASSIFICATION_STATUSES_URL;
  }
  classifications() {
    return urls.CLASSIFICATIONS_URL;
  }
  classification(classificationId) {
    return this._itemlUrl(urls.CLASSIFICATIONS_URL, classificationId);
  }
  models() {
    return urls.MODELS_URL;
  }
  entities() {
    return urls.ENTITIES_URL;
  }
  knowledgeItems() {
    return urls.KNOWLEDGES_URL;
  }
  knowledgeItem(knowledgeItemId) {
    return this._itemlUrl(urls.KNOWLEDGES_URL, knowledgeItemId);
  }
  knowledgeTypes() {
    return urls.KNOWLEDGE_TYPES_URL;
  }
  knowledgeCopyrights() {
    return urls.KNOWLEDGE_COPYRIGHTS_URL;
  }
  knowledgeSources() {
    return urls.KNOWLEDGE_SOURCES_URL;
  }
  lifeCycles() {
    return urls.LIFE_CYCLES_URL;
  }
  lifeCycle(lifeCycleId) {
    return this._itemlUrl(urls.LIFE_CYCLES_URL, lifeCycleId);
  }
  documents() {
    return urls.DOCUMENTS_URL;
  }
  entityRatings() {
    return urls.ENTITY_RATINGS_URL;
  }
  entityMessageLogs() {
    return urls.ENTITY_MESSAGE_LOGS;
  }
  entityMessageLogTypes() {
    return urls.ENTITY_MESSAGE_LOG_TYPES;
  }
  lifeCycleStateType(lifeCycleStateTypeId) {
    return this._itemlUrl(
      urls.LIFE_CYCLE_STATE_TYPES_URL,
      lifeCycleStateTypeId
    );
  }
  lifeCycleStateTypes() {
    return urls.LIFE_CYCLE_STATE_TYPES_URL;
  }
  lifeCycleClassDefinition(lifeCycleClassDefinitionId) {
    return this._itemlUrl(
      urls.LIFE_CYCLE_CLASS_DEFINITION_URL,
      lifeCycleClassDefinitionId
    );
  }
  lifeCycleClassDefinitions() {
    return urls.LIFE_CYCLE_CLASS_DEFINITION_URL;
  }
  involvementRoles() {
    return urls.INVOLVEMENT_ROLES;
  }
  involvementRoleTypes() {
    return urls.INVOLVEMENT_ROLE_TYPES;
  }
  partyRoles() {
    return urls.PARTY_ROLES;
  }
  partyRoleTypes() {
    return urls.PARTY_ROLES_TYPES;
  }
  partyRoleTypeDiscriminator() {
    return urls.PARTY_ROLE_TYPE_DISCRIMINATORS;
  }
  extensions() {
    return urls.EXTENSIONS_URL;
  }
  userPartyIdUrl(partyId) {
    return this._itemlUrl(urls.USERS_PARTY_URL, partyId);
  }
  partyClassificationsByOperation(partyId) {
    return this._itemlUrl(
      urls.USERS_PARTY_CLASSIFICATIONS_BY_OPERATION_URL,
      partyId
    );
  }
  operations() {
    return urls.OPERATIONS_URL;
  }
  languagesUrl() {
    return urls.LANGUAGES_URL;
  }
  partiesUrl() {
    return urls.PARTIES_URL;
  }
}

export default UrlFactory;
